<template>
  <a href="#" v-on:click="trackClick" class="icons snipcart-customer-signin clickable">
    <i class="ti-user" aria-hidden="true" style="font-size:24px"></i>
  </a>
</template>

<script>
export default {
  methods: {
    trackClick (e) {
      console.log('ViewUserAccount')
      window.analytics.track('Viewed User Account')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account.vue